{
  "pt": {
    "timestamp": {
      "labels": {
        "accepted": "Aceite {date}",
        "ago": "atrás",
        "daysAgo": "{days} dia |{days} dias",
        "daysRemaining": "{days} dias restantes",
        "deadlineDaysLeft": "Faltam {days} dias",
        "deadlineOverdue": "Em atraso",
        "due": "Prazo: {date}",
        "dueToday": "Prazo hoje",
        "dueWas": "Prazo terminou: {date}",
        "expired": "Expirado {date}",
        "hoursAgo": "{hours} hora | {hours} horas",
        "in": "Em {time}",
        "justNow": "Agora mesmo",
        "minutesAgo": "{minutes} minuto | {minutes} minutos",
        "monthsAgo": "{months} mês | {months} meses",
        "noDeadline": "Sem prazo definido",
        "overdue": "Vencido há {days} dias",
        "sentOn": "Enviado em {date}",
        "sentOnAt": "Enviado em {date} às {time}",
        "starts": "Começa {date}",
        "today": "Hoje",
        "tomorrow": "Amanhã",
        "uploaded": "Carregado {date}",
        "weeksAgo": "{weeks} semana | {weeks} semanas",
        "yearsAgo": "{years} ano | {years} anos",
        "yesterday": "Ontem"
      }
    }
  }
}
